module.exports = __webpack_public_path__ + "static/media/Supplement.baf6f583.png";